
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { GlobalComponent } from "src/app/global-component";

import { SortByValuesModel } from "../../../../core/models/table/sort-by-values.model";
import { TableConfigurationModel } from "../../../../core/models/table/table-configuration.model";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { AccountStatus } from "src/app/core/models/members/user/user.model";
import { BoolEnum } from "src/app/core/enums/bool-enum";
import { ClientPickListFilter } from "./client-picklist-filter-config-enum";

export class ClientPickListTableConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Client Pick List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeLG },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeXL }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'number',
                title: 'Number',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 1,
                width: "70px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'fullName',
                title: 'Name',
                sortable: new SortByValuesModel('name'),
                visible: 'true',
                order: 2,
                width: "200px",
                type: ColumnTypeEnum.PhotoModel,
            },

            {
                dataFieldName: 'email',
                title: 'Email',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "150px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'phoneNumber',
                title: 'Phone Number',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 4,
                width: "125px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'matterNumber',
                title: 'Matter Number',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 5,
                width: "125px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'status',
                title: 'Status',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 6,
                width: "100px",
                type: ColumnTypeEnum.Status,
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 7,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = [
            {
                label: ClientPickListFilter.ClientEnabledFilter,
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Show All`, $localize`:@@:Show All`, undefined, true),
                    new NgSelectListModel(BoolEnum.True, $localize`:@@Contact_Status_Enabled:Enabled`, $localize`:@@Contact_Status_Enabled:Enabled`, "bx bx-check-circle"),
                    new NgSelectListModel(BoolEnum.False, $localize`:@@Contact_Status_Disabled:Disabled`, $localize`:@@Contact_Status_Disabled:Disabled`, "bx bx-error-alt"),
                ],
                selectedOption: undefined,
                inDropdown: false,
                inHeading: false,
                inButton: true,
            },
            {
                label: ClientPickListFilter.ClientStatusFilter,
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Select Status`, $localize`:@@:Select Status`, undefined, true),
                    new NgSelectListModel(AccountStatus.Approved, $localize`:@@:Approved`, $localize`:@@:Approved`),
                    new NgSelectListModel(AccountStatus.Disabled, $localize`:@@:Disabled`, $localize`:@@:Disabled`),
                    new NgSelectListModel(AccountStatus.Onboarding, $localize`:@@:Onboarding`, $localize`:@@:Onboarding`),
                    new NgSelectListModel(AccountStatus.PasswordReset, $localize`:@@:Password Reset`, $localize`:@@:Password Reset`),
                    new NgSelectListModel(AccountStatus.Pending, $localize`:@@:Pending`, $localize`:@@:Pending`),
                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            }
        ]
        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search for Client number, name, company name, or email"
        }
        this.actions = [

            {
                visible: SecurityOperations.client.clientUpdate,
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: false
            },
            {
                visible: SecurityOperations.client.clientRead,
                label: 'Notes',
                actionId: ActionIdEnum.Notes,
                icon: 'ri-file-list-2-fill',
                inDropdown: true,
                inList: false
            },
            {
                visible: SecurityOperations.client.clientDelete,
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false
            },
        ]
        this.buttons = [
            {
                visible: SecurityOperations.client.clientCreate,
                label: "Create New",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            }
        ],
            this.doubleClickSelect =
            {
                action: ActionIdEnum.Select,
                enabled: true
            }
    }
}